import { useGetPatientReports } from "../useReportQueries";
import React, { useEffect, useRef, useState } from "react";
import CanvasJSReact from "@canvasjs/react-charts";
import { generateMixedChart } from "./reportUtils/utils";

const MixedReport = ({ patient_id, startDate, endDate }) => {
  var CanvasJSChart = CanvasJSReact.CanvasJSChart;

  const [layout, setLayout] = useState(null);

  // report data
  const getSpo2Reports = useGetPatientReports(patient_id, 1);
  const getPressureReports = useGetPatientReports(patient_id, 3);
  const getTemperatureReports = useGetPatientReports(patient_id, 4);

  const updateChart = (_startDate, _endDate) => {
    // restrict data to the selected date range
    const filteredSpo2Reports = getSpo2Reports.data.reports.filter(
      (report) =>
        new Date(report.data.Date) >= new Date(_startDate) &&
        new Date(report.data.Date) <= new Date(_endDate),
    );

    const filteredPressureReports = getPressureReports.data.reports.filter(
      (report) =>
        new Date(report.data.Date) >= new Date(_startDate) &&
        new Date(report.data.Date) <= new Date(_endDate),
    );

    const filteredTemperatureReports =
      getTemperatureReports.data.reports.filter(
        (report) =>
          new Date(report.data.Date) >= new Date(_startDate) &&
          new Date(report.data.Date) <= new Date(_endDate),
      );

    const layout = generateMixedChart(
      filteredPressureReports,
      filteredSpo2Reports,
      filteredTemperatureReports,
    );
    setLayout(layout);
  };

  useEffect(() => {
    if (
      getSpo2Reports.data &&
      getPressureReports.data &&
      getTemperatureReports.data
    ) {
      updateChart(startDate, endDate);
      console.log(layout);
    }
  }, [startDate, endDate]);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {layout !== null && <CanvasJSChart options={layout} />}
    </div>
  );
};

export default MixedReport;
